class EemFreeShippingProgress extends HTMLElement {
  connectedCallback() {
    this.updateFromValues(Number(this.dataset.current || 0));
    this.handleCartUpdate = () => this.refresh();
    document.addEventListener('cart:update', this.handleCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.handleCartUpdate);
  }

  async refresh() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      this.updateFromValues(Number(cart.total_price || 0));
    } catch {
      // The server-rendered value remains visible if a cart refresh is unavailable.
    }
  }

  updateFromValues(current) {
    const threshold = Number(this.dataset.threshold || 10500);
    const remaining = Math.max(0, threshold - current);
    const unlocked = remaining === 0;
    const context = this.dataset.context || 'cart';
    const progress = Math.min(100, Math.max(0, (current / threshold) * 100));
    const message = this.querySelector('[data-eem-free-shipping-message]');
    const detail = this.querySelector('[data-eem-free-shipping-detail]');
    const badge = this.querySelector('[data-eem-free-shipping-badge]');
    const bar = this.querySelector('[data-eem-free-shipping-bar]');
    const status = this.querySelector('[data-eem-free-shipping-status]');
    const progressbar = this.querySelector('[role="progressbar"]');

    this.dataset.current = String(current);
    this.dataset.unlocked = String(unlocked);

    if (unlocked) {
      message.textContent = 'Free U.S. standard shipping unlocked';
      detail.textContent = 'Your order qualifies automatically at checkout.';
      badge.textContent = 'Unlocked';
      status.textContent = 'Ready at checkout';
    } else if (context === 'product' && current === 0) {
      message.textContent = `Free U.S. standard shipping on ${this.formatMoney(threshold)}+ orders`;
      detail.textContent = 'Build your rotation and we’ll cover U.S. delivery.';
      badge.textContent = `${this.formatMoney(threshold)}+`;
      status.textContent = 'Automatic at checkout';
    } else {
      message.textContent = `You’re ${this.formatMoney(remaining)} away from free standard shipping`;
      detail.textContent = 'Add another pair to move closer to the goal.';
      badge.textContent = `${this.formatMoney(threshold)}+`;
      status.textContent = 'Automatic at checkout';
    }

    bar.style.width = `${progress}%`;
    progressbar.setAttribute('aria-valuenow', String(Math.min(current, threshold)));
  }

  formatMoney(cents) {
    const currency = this.dataset.currency || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: cents % 100 === 0 ? 0 : 2,
    }).format(cents / 100);
  }
}

if (!customElements.get('eem-free-shipping-progress')) {
  customElements.define('eem-free-shipping-progress', EemFreeShippingProgress);
}
